import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── STRIP CARD ───────────────────────────────────────────────────────────────
// Used for "Trending Now". Clean, minimal, white card with a slim colored
// top bar and a single info row — deliberately quieter/denser than the
// wave-cut Showcase style, for visual contrast between sections.
export default function StripCard({ p, onNav, accent }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:14, overflow:"hidden", cursor:"pointer", background:"white",
        border:"1px solid #f0f0f0",
        boxShadow: hovered ? "0 14px 32px rgba(0,0,0,0.1)" : "0 2px 10px rgba(0,0,0,0.05)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        transition:"all 0.3s ease",
      }}>
      {/* Slim colored top bar */}
      <div style={{ height:5, background:accent }}/>

      <div style={{ height:260, position:"relative", overflow:"hidden", background:meta.light||"#fafafa" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"top", transition:"transform 0.5s ease", transform:hovered?"scale(1.06)":"scale(1)" }} loading="lazy"/>
          : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:52, opacity:0.25 }}>{meta.emoji}</div>
        }
        <div style={{ position:"absolute", top:10, left:10, background:"white", color:accent, fontSize:9, fontWeight:800, padding:"3px 10px", borderRadius:6, letterSpacing:0.5, textTransform:"uppercase" }}>
          {meta.emoji} {p.category}
        </div>
        {disc > 0 && (
          <span style={{ position:"absolute", top:10, right:10, background:accent, color:"white", fontSize:10, fontWeight:800, padding:"3px 9px", borderRadius:6 }}>
            -{disc}%
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", bottom:10, right:10, background:"white", border:"none", borderRadius:"50%", width:28, height:28, fontSize:13, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(0,0,0,0.15)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>

      {/* Single compact info row */}
      <div style={{ padding:"12px 14px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:10 }}>
        <div style={{ minWidth:0 }}>
          <div style={{ fontWeight:700, fontSize:13, color:"#1a1a2e", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", marginBottom:2 }}>{p.name}</div>
          <div style={{ display:"flex", alignItems:"baseline", gap:6 }}>
            <span style={{ fontSize:14.5, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
            {p.mrp > p.price && <span style={{ fontSize:10, color:"#aaa", textDecoration:"line-through" }}>₹{p.mrp?.toLocaleString("en-IN")}</span>}
          </div>
        </div>
        {p.stock > 0 && (
          <button onClick={addCart} style={{ background:accent, color:"white", border:"none", width:32, height:32, borderRadius:"50%", fontSize:16, fontWeight:700, cursor:"pointer", flexShrink:0, lineHeight:1 }}>
            +
          </button>
        )}
      </div>
    </div>
  );
}
